import { Dayjs } from "dayjs";
import { DateModel } from "../../../../shared/models/date.model";
import { DailyEfficiencySummary } from "../models/dailyEfficiencySummary.model";

export interface DailyEfficiencySummaryInitialState {
    chartData: DailyEfficiencySummary[];
    forklifts: string[];
    organizations: string[];
    companies: string[];
    departments: string[];
    models: string[];
    activities: string[];
    tags: string[];
    dates: DateModel;
    showFilters: boolean;
    startDate: Dayjs | null;
    endDate: Dayjs | null;
}

const initialDailyEfficiencySummaryState: DailyEfficiencySummaryInitialState = {
    chartData: [],
    forklifts: [],
    organizations: [],
    companies: [],
    departments: [],
    models: [],
    activities: [],
    tags: [],
    dates: { startDate: null, endDate: null },
    showFilters: true,
    startDate: null,
    endDate: null
};

export default initialDailyEfficiencySummaryState;
